module.exports = __webpack_public_path__ + "static/media/git.3e54ed15.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/git.png
// module id = 45
// module chunks = 0